import Vue from 'vue'
import Router from 'vue-router'
import dashboard from "./pages/dashboard.vue";
import adhocScan from "./pages/adhocScan.vue";
import adhocScanAuto from "./pages/adhocScanAuto.vue";

import catCodes from "./pages/catCodes.vue";
import catCode from "./pages/catCode.vue";
import catCodeEdit from "./pages/catCodeEdit.vue";

import partGroups from "./pages/partGroups.vue";
import partGroupEdit from "./pages/partGroupEdit.vue";

import snapshots from "./pages/snapshots.vue";
import snapshot from "./pages/snapshot.vue";
import snapshotApiCalls from "./pages/snapshotApiCalls.vue";

import logout from "./pages/logout.vue";
import sellers from "./pages/sellers.vue";
import excludedListings from "./pages/excludedListings.vue";
import categoryKeywords from "./pages/categoryKeywords.vue";
import applicationEvents from "./pages/applicationEvents.vue";
import orderTracking from "./pages/orderTracking.vue";

const DEFAULT_TITLE = 'MarketScout';

//export default new Router({
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Dashboard",
      icon: "dashboard",
      topLevel: true,
      component: dashboard,
      meta: {
        title: "Dashboard"
      }
    },
    {
      path: "/adhocScan",
      name: "Ad-hoc Scan",
      icon: "mdi-search-web",
      topLevel: true,
      component: adhocScan,
      meta: {
        title: "Ad-hoc Scan"
      }
    },
    {
      path: "/adhocScan/auto/:catCode",
      name: "Ad-hoc Scan Auto",
      topLevel: false,
      component: adhocScanAuto,
      meta: {
        title: "Ad-hoc Scan"
      }
    },
    {
      path: "/snapshots",
      name: "Snapshots",
      icon: "camera_alt",
      topLevel: true,
      component: snapshots,
      meta: {
        title: "Snapshots"
      }
    },
    {
      path: "/snapshot/:id",
      name: "Snapshot",
      icon: "camera_alt",
      topLevel: false,
      component: snapshot,
      meta: {
        title: "Snapshot"
      }
    },
    {
      path: "/snapshot/:id/apiCalls",
      name: "Snapshot API Calls",
      icon: "camera_alt",
      topLevel: false,
      component: snapshotApiCalls,
      meta: {
        title: "Snapshot API Calls"
      }
    },
    {
      path: "/snapshot/latest/:catCode",
      name: "Latest Snapshot",
      icon: "camera_alt",
      topLevel: false,
      component: snapshot,
      meta: {
        title: "Latest Snapshot"
      }
    },
    {
      path: "/snapshot/latest/:marketplace/:catCode",
      name: "Latest Snapshot for Marketplace",
      icon: "camera_alt",
      topLevel: false,
      component: snapshot,
      meta: {
        title: "Latest Snapshot for Marketplace"
      }
    },
    {
      path: "/catCodes",
      name: "CatCodes",
      icon: "developer_board",
      topLevel: true,
      component: catCodes,
      meta: {
        title: "Cat Codes"
      }
    },
    {
      path: "/catCode/:catCodeString",
      name: "CatCode",
      icon: "developer_board",
      topLevel: false,
      component: catCode,
      meta: {
        title: "Cat Code"
      }
    },
    {
      path: "/catCodes/edit/:id",
      name: "CatCodeEdit",
      icon: "developer_board",
      topLevel: false,
      component: catCodeEdit,
      meta: {
        title: "Edit Cat Code"
      }
    },
    {
      path: "/catCodes/edit/byString/:catCodeString",
      name: "CatCodeEditByString",
      icon: "developer_board",
      topLevel: false,
      component: catCodeEdit,
      meta: {
        title: "Edit Cat Code By String"
      }
    },
    {
      path: "/partGroups",
      name: "PartGroups",
      icon: "developer_board",
      topLevel: true,
      component: partGroups,
      meta: {
        title: "Part Groups"
      }
    },
    {
      path: "/partGroups/edit/:id",
      name: "PartGroupEdit",
      icon: "developer_board",
      topLevel: false,
      component: partGroupEdit,
      meta: {
        title: "Edit Part Group"
      }
    },
    {
      path: "/partGroups/edit/byName/:name",
      name: "PartGroupEditByName",
      icon: "developer_board",
      topLevel: false,
      component: partGroupEdit,
      meta: {
        title: "Edit Part Group By Name"
      }
    },
    {
      path: "/categoryKeywords",
      name: "Category Keywords",
      icon: "mdi-file-tree",
      topLevel: true,
      component: categoryKeywords,
      meta: {
        title: "Category Keywords"
      }
    },
    {
      path: "/sellers",
      name: "Seller Ratings",
      icon: "mdi-account-star",
      topLevel: true,
      component: sellers,
      meta: {
        title: "Seller Ratings"
      }
    },
    {
      path: "/excludedSellers",
      redirect: { path: "/sellers", query: { tier: "Excluded" } }
    },
    {
      path: "/excludedListings",
      name: "Excluded Listings",
      icon: "mdi-eye-off",
      topLevel: true,
      component: excludedListings,
      meta: {
        title: "Excluded Listings"
      }
    },
    {
      path: "/applicationEvents",
      name: "Errors",
      icon: "mdi-alert-circle-outline",
      topLevel: true,
      component: applicationEvents,
      meta: {
        title: "Errors"
      }
    },
    {
      path: "/orderTracking",
      name: "Order Tracking",
      icon: "mdi-truck-delivery-outline",
      topLevel: true,
      component: orderTracking,
      meta: {
        title: "Order Tracking",
        requiresClientID: 1
      }
    },
    /*
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/About.vue')
    }
    */
   {
      path: "/logout",
      name: "Logout",
      icon: "exit_to_app",
      topLevel: true,
      component: logout,
      meta: {
        title: "Logout"
      }
   },
  ]
})

router.afterEach((to, from) => {
  if (to.meta.title == null)
  {
    document.title = DEFAULT_TITLE
  } else {
    document.title = to.meta.title + ' - ' + DEFAULT_TITLE;
  }
});

export default router

Vue.use(Router)